//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.Azure.Pipelines.Checks.WebApi
// Microsoft.Azure.Pipelines.Checks.Common
// Microsoft.Azure.Pipelines.TaskCheck.WebApi
//----------------------------------------------------------


/// <amd-module name="Checks/ChecksOverview/Generated/Constants" />
export module FeatureFlagConstants {
    export const EnableChecksScalabilityPhase1Warnings = "Pipelines.Checks.EnableChecksScalabilityPhase1Warnings";
    export const EnableChecksScalabilityPhase2Errors = "Pipelines.Checks.EnableChecksScalabilityPhase2Errors";
    export const EnableChecksScalabilityPhase3FailCheckRuns = "Pipelines.Checks.EnableChecksScalabilityPhase3FailCheckRuns";
    export const EnableChecksScalabilityResourceIssues = "Pipelines.Checks.EnableChecksScalabilityResourceIssues";
    export const EnableDisabledChecksFeature = "Pipelines.Checks.EnableDisabledChecksFeature";
    export const ResourceListOptimizations = "Pipelines.Policy.ResourceListOptimizations";
    export const EnableOrderingChecks = "Pipelines.Checks.EnableOrderingChecks";
    export const AllowChangingApprovalOrder = "Pipelines.Checks.AllowChangingApprovalOrder";
}

export module ResourceTypeNames {
    export const ServiceEndpoint = "endpoint";
    export const Queue = "queue";
    export const SecureFile = "securefile";
    export const VariableGroup = "variablegroup";
    export const Environment = "environment";
    export const AgentPool = "agentpool";
    export const Repository = "repository";
}

export module TaskCheckConstants {
    export const TaskCheckTypeId = "fe1de3ee-a436-41b4-bb20-f6eb4cb879a7";
    export const InvokeRestApiTaskId = "9c3e8943-130d-4c78-ac63-8af81df62dfb";
    export const AzureFunctionTaskId = "537fdb7a-a601-4537-aa70-92645a2b5ce4";
    export const ApprovalCheckTypeId = "8c6f20a7-a545-4486-9777-f762fafe0d4d";
    export const PreApprovalDefTypeId = "0f52a19b-c67e-468f-b8eb-0ae83b532c99";
    export const MainApprovalDefTypeId = "26014962-64a0-49f4-885b-4b874119a5cc";
    export const PostApprovalDefTypeId = "06441319-13fb-4756-b198-c2da116894a4";
    export const TaskCheckTypeName = "Task Check";
    export const TaskCheckMaxSyncRetries = "TaskCheck.MaxSyncRetries";
    export const TaskCheckScalabilityComplianceDeadline = "TaskCheck.ScalabilityComplianceDeadline";
    export const TaskCheckDefaultRetryIntervalInMinutes = "TaskCheck.DefaultRetryIntervalInMinutes";
    export const TaskCheckDefaultTimeoutInMinutes = "TaskCheck.DefaultTimeoutInMinutes";
}

